import React from 'react';

// styles
import { BoxBtnContainer } from './BoxBtn.styles.js';

const BoxBtn = React.memo(function BoxBtn({ 
  disabled = false, 
  title, 
  onClick, 
  type = 'default' 
}) {
  return (
    <BoxBtnContainer 
      className="panel-bg" 
      disabled={disabled}
      onClick={onClick}
      $type={type}
    >
      {title}
    </BoxBtnContainer>
  );
});

export default BoxBtn;